var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315,
    height: 64,
    viewBox: "0 0 315 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(-782 -266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(0 79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 315,
    height: 64,
    rx: 5,
    transform: "translate(782 187)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(73.635 93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-2",
    "data-name": "Rectangle 37",
    width: 216,
    height: 18,
    rx: 5,
    transform: "translate(782.365 187)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(17.635 93)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-3",
    "data-name": "Rectangle 37",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(782.365 187)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(103.635 118)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37-4",
    "data-name": "Rectangle 37",
    width: 186,
    height: 12,
    rx: 5,
    transform: "translate(782.365 187)",
    fill: "#e4e4e4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.ff6942ced1979ac0c2868a267a126b58.svg";
export { ForwardRef as ReactComponent };